export default function (group, chart, index) {
  if (!chart) return group.defaultFilterValue;

  return (
    (chart.series && chart.series[index] && chart.series[index].userOptions?.type) ||
    (chart.options && chart.options.chart && chart.options.chart.type) ||
    group.defaultFilterValue
  );
}
